import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  "In Progress": "bg-[hsl(200,50%,92%)] text-[hsl(200,60%,28%)] border-[hsl(200,40%,80%)]",
  Incomplete: "bg-[hsl(8,60%,94%)] text-[hsl(8,54%,38%)] border-[hsl(8,50%,82%)]",
  "Awaiting Review": "bg-[hsl(33,70%,92%)] text-[hsl(33,65%,34%)] border-[hsl(33,60%,80%)]",
  Approved: "bg-[hsl(150,40%,90%)] text-[hsl(150,45%,24%)] border-[hsl(150,35%,76%)]",
};

export default function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      className={`font-medium ${MAP[status] || "bg-muted text-muted-foreground"}`}
      data-testid={`status-${status.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {status}
    </Badge>
  );
}
